import { type ReactNode } from 'react';
import { cn } from '../utils';

export interface BreakdownItem {
  label: ReactNode;
  count: number;
  /** Optional swatch color (any CSS color) shown before the label. */
  color?: string;
}

export interface EntityBreakdownProps {
  items: BreakdownItem[];
  className?: string;
}

export const EntityBreakdown = ({ items, className }: EntityBreakdownProps) => (
  <div className={cn('flex flex-wrap gap-1.5', className)}>
    {items.map((item) => (
      <span
        key={String(item.label)}
        className="inline-flex items-center gap-1.5 rounded-lg border border-default-300/60 bg-content2/70 px-2.5 py-1 text-xs text-default-600">
        {item.color && (
          <span
            className="h-2 w-2 flex-none rounded-[3px]"
            style={{ backgroundColor: item.color }}
            aria-hidden="true"
          />
        )}
        <span>{item.label}</span>
        <span className="font-semibold tabular-nums text-foreground">{item.count}</span>
      </span>
    ))}
  </div>
);
